/*
 * @Description:
 * @Author: JiuYue
 * @Date: 2020-10-13 14:24:38
 * @Reference:
 */
export default {
  className: '_User',
  fields: [
    'avatarUrl',
    {
      name: 'wechatName',
      note: '昵称',
      disabled: true
    }
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.authority = {
        $ne: 'administrator'
      }
    }
  },
  action: false
}
